(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["johnson-zuze-sculpture"]) return;
  try {
    
(function(){
  document.querySelectorAll('.jz-page').forEach(function(page){
    var modal = page.querySelector('.jz-modal');
    if(!modal) return;
    var mImg = modal.querySelector('[id^="jz-modal-img-"]');
    var mTitle = modal.querySelector('[id^="jz-modal-title-"]');
    var mMedium = modal.querySelector('[id^="jz-modal-medium-"]');
    var mCta = modal.querySelector('[id^="jz-modal-cta-"]');
    var closeBtn = modal.querySelector('.jz-modal-close');
    var last = null;

    function openModal(card){
      mImg.src = card.dataset.jzImg;
      mImg.alt = card.dataset.jzAlt || '';
      mTitle.textContent = card.dataset.jzTitle || '';
      mMedium.textContent = card.dataset.jzMedium || '';
      var wordmark = page.dataset.jzWordmark || '';
      var subject = 'Inquiry: "' + (card.dataset.jzTitle || '') + '"' + (wordmark ? ' by ' + wordmark : '');
      var baseHref = mCta.getAttribute('href') || '#';
      var mailBase = baseHref.split('?')[0];
      mCta.href = mailBase + '?subject=' + encodeURIComponent(subject);
      last = card;
      modal.setAttribute('data-jz-open', '');
      document.body.style.overflow = 'hidden';
      closeBtn.focus();
    }
    function closeModal(){
      modal.removeAttribute('data-jz-open');
      document.body.style.overflow = '';
      if(last){ last.focus(); last = null; }
    }
    page.querySelectorAll('.jz-card').forEach(function(c){
      c.addEventListener('click', function(){ openModal(c); });
    });
    if(closeBtn) closeBtn.addEventListener('click', closeModal);
    modal.addEventListener('click', function(e){ if(e.target === modal) closeModal(); });
    document.addEventListener('keydown', function(e){
      if(e.key === 'Escape' && modal.hasAttribute('data-jz-open')) closeModal();
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jz-collection"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('.jz-section--collection').forEach(function(page){
    var modal = page.querySelector('.jz-modal');
    if(!modal) return;
    var mImg = modal.querySelector('[id^="jz-modal-img-"]');
    var mTitle = modal.querySelector('[id^="jz-modal-title-"]');
    var mMedium = modal.querySelector('[id^="jz-modal-medium-"]');
    var mCta = modal.querySelector('[id^="jz-modal-cta-"]');
    var closeBtn = modal.querySelector('.jz-modal-close');
    var last = null;

    function openModal(card){
      mImg.src = card.dataset.jzImg;
      mImg.alt = card.dataset.jzAlt || '';
      mTitle.textContent = card.dataset.jzTitle || '';
      mMedium.textContent = card.dataset.jzMedium || '';
      var artistName = page.dataset.jzArtistName || '';
      var subject = 'Inquiry: "' + (card.dataset.jzTitle || '') + '"' + (artistName ? ' by ' + artistName : '');
      var baseHref = mCta.getAttribute('href') || '#';
      var mailBase = baseHref.split('?')[0];
      mCta.href = mailBase + '?subject=' + encodeURIComponent(subject);
      last = card;
      modal.setAttribute('data-jz-open', '');
      document.body.style.overflow = 'hidden';
      closeBtn.focus();
    }
    function closeModal(){
      modal.removeAttribute('data-jz-open');
      document.body.style.overflow = '';
      if(last){ last.focus(); last = null; }
    }
    page.querySelectorAll('.jz-card').forEach(function(c){
      c.addEventListener('click', function(){ openModal(c); });
    });
    if(closeBtn) closeBtn.addEventListener('click', closeModal);
    modal.addEventListener('click', function(e){ if(e.target === modal) closeModal(); });
    document.addEventListener('keydown', function(e){
      if(e.key === 'Escape' && modal.hasAttribute('data-jz-open')) closeModal();
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jz-hero"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('.jz-mosaic-link').forEach(function(link){
    link.addEventListener('click', function(e){
      e.preventDefault();
      var imgId = link.getAttribute('data-jz-mosaic-img-id');
      var matchedCard = null;
      if (imgId) {
        matchedCard = document.querySelector('.jz-section--collection [data-jz-image-id="' + imgId + '"]');
      }
      if (matchedCard) {
        matchedCard.scrollIntoView({ behavior: 'smooth', block: 'center' });
        matchedCard.classList.add('jz-flash');
        window.setTimeout(function(){ matchedCard.classList.remove('jz-flash'); }, 1200);
      } else {
        var section = document.getElementById('collection');
        if (section) {
          section.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
